export default __webpack_public_path__ + "static/media/line-shape-14.e5af41d8.svg";